import { Api } from '@/services/Api'

export default {
  getStringEvaluationData(plantId) {
    return Api().get(`/api/v1.0/stringEvaluation/${plantId}`)
  }
}